import React from "react"

export function LegacyUserDropdownPositioner({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative">
      <div className={`absolute w-100`}>
        <div className="flex justify-end">
          <div className="mr3 mr0-ns mt5-ns">{children}</div>
        </div>
      </div>
    </div>
  )
}
